// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import './assets/css/common.css'
import './assets/css/font.css'
import './assets/js/common'
import { showShare } from './assets/js/common'
import Vue from 'vue'
import App from './App'
import router from './router'
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';

Vue.config.productionTip = false

import wx from "weixin-js-sdk"
Vue.prototype.$wx = wx
Vue.config.productionTip = false
Vue.config.ignoredElements = [
  'wx-open-launch-app',
]



try {
  showShare().then(res => {
    console.log('res :>> ', res);
  }).catch(err => {
    console.log('err :>> ', err);
  })
} catch (error) {
  console.log(error)
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
console.log('ver 1.0.5');
